import React, { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './OrganizationHqView.css';

import { apiUrl } from '../../../utility/Connections';

import { Layout, Divider } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import TableOrganizationHq from '../../../components/tableOrganizationHq/tableOrganizationHq';
import FormOrganizationHq from '../../../components/formOrganizationHq/formOrganizationHq';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import Search from '../../../components/search/search';
const { Content } = Layout;

const OrganizationHqView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [filteredDataOrganizationHq, setFilteredDataOrganizationHq] = useState([]);
    const [dataOrganizationHq, setDataOrganizationHq] = useState([]);
    const [orgId, setOrgId] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            getOrganizationHq(current_org.org_id);
        }
    }, []);

    const getOrganizationHq = (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando sedes de la organización...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/organization-hqs/get-organization-hqs/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataOrganizationHq(data);
                setShowLoading(false);
                if (searchText) {
                    filterData(searchText, data)
                } else {
                    setFilteredDataOrganizationHq(data);
                }
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para agregar un nuevo registro de sede
    const addOrganizationHq = (newOrganizationHq) => {
        setShowLoading(true);
        setLoadingText("Agregando sede...")

        const formData = new FormData();
        formData.append("ohq_org_id", orgId);
        formData.append("ohq_location", newOrganizationHq);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.post(`${apiUrl}/organization-hqs/create-organization-hq/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getOrganizationHq(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para editar el nombre de una sede
    const handleInputChangeTable = (ohq_id, managementArea) => {
        setShowLoading(true);
        setLoadingText("Guardando sede...")

        const formData = new FormData();
        formData.append("ohq_id", ohq_id);
        formData.append("ohq_location", managementArea);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.put(`${apiUrl}/organization-hqs/update-organization-hq/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getOrganizationHq(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    // Función para eliminar un registro de sede
    const handleDeleteTable = (ohq_id) => {
        setShowLoading(true);
        setLoadingText("Eliminando sede...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.delete(`${apiUrl}/organization-hqs/delete-organization-hq/${ohq_id}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getOrganizationHq(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const onSearch = (value) => {
        setSearchText(value)
        filterData(value, dataOrganizationHq)
    }

    const filterData = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataOrganizationHq(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.ohq_location.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataOrganizationHq(filtered);
        }
    }

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            <div className='layout-content'>
                <FormOrganizationHq addOrganizationHq={addOrganizationHq} />
            </div>
            <Divider />
            <div className='layout-content'>
                <Search onSearch={onSearch} />
                <br></br>
                <TableOrganizationHq data={filteredDataOrganizationHq} handleInputChange={handleInputChangeTable} handleDelete={handleDeleteTable} />
            </div>
        </Content>
    </div>
}

export default OrganizationHqView;